import React from 'react';
import { Input } from 'reactstrap';

import { isUnrecognisedOption, isUnrecognisedValue } from '../fieldUtils';

// Options may be {label, value} pairs or bare values.
const normalizeOption = (option) =>
  option != null && typeof option === 'object'
    ? { label: option.label, value: option.value, raw: option }
    : { label: option, value: option, raw: option };

const SelectField = ({ field, value, onChange, disabled }) => {
  const options = (field.options || []).map(normalizeOption);
  // A stored value the registry no longer knows about is surfaced as an extra
  // option so the screen shows what is actually in force — but re-submitting it
  // is rejected, so flag it rather than letting it read as a normal choice.
  const stale = isUnrecognisedValue(field, value);

  return (
    <div>
      <Input
        type="select"
        name={field.key}
        value={value == null ? '' : value}
        onChange={(e) => onChange(field.key, e.target.value)}
        style={{ maxWidth: '500px' }}
        className={stale ? 'border-warning' : undefined}
      >
        <option value="" disabled>
          Choose…
        </option>
        {options.map((option) => (
          <option key={String(option.value)} value={option.value}>
            {option.label}
          </option>
        ))}
      </Input>
      {stale && (
        <small
          className="text-warning"
          style={{ display: 'block', marginTop: '6px' }}
        >
          <i
            className="now-ui-icons ui-1_bell-53"
            style={{ marginRight: '6px' }}
          />
          This value is in force but is no longer a recognised option. Pick a
          valid option — saving it as-is will be rejected.
        </small>
      )}
      {!stale && options.some((option) => isUnrecognisedOption(option.raw)) && (
        <small
          className="text-muted"
          style={{ display: 'block', marginTop: '6px' }}
        >
          One listed option is no longer recognised and cannot be saved.
        </small>
      )}
    </div>
  );
};

export default SelectField;
